import React from 'react';
import { Link } from 'react-router-dom';
import githubsquare from './images/githubsquare2.png';
import mesh from './images/mesh.jpg';
import litupwardriver from './images/wardriver.jpg';
import dotbackground from './images/dotbackground.png';
import crtterminal from './images/crtterminal.png';
import { useEthPrice } from './hooks/useEthPrice';
import './Shop.css';
import orangepi5procase from './images/orangepi5procase2.JPG';

function Shop() {
  const { ethPrice: standardEthPrice, isLoading: standardLoading } = useEthPrice(10);
  const { ethPrice: meshtasticEthPrice, isLoading: meshtasticLoading } = useEthPrice(15);
  const { ethPrice: orangePiEthPrice, isLoading: orangePiLoading } = useEthPrice(5);
  
  const ethToUsd = 3500;

  const formatUsdPrice = (ethPrice) => {
    return (ethPrice * ethToUsd).toFixed(2);
  };

  return (
    <section className="projectssection" aria-labelledby="services-title">
      <div id="services"></div>
      <h1 id="services-title" className="projectstitle">Shop</h1>

      <div className="cards-container">
        <div id="card-list2" className="card-list">
          <Link to="/GithubActivityCalendar" className="card-item2 card-item-1">
            <img src={githubsquare} alt="A screenshot of a website showcasing web development services" />
            <br />
            <br />
            <h3>GitHub Activity Calendar</h3>
            <br />
            <p className="carddescription">Show off your github activity to your friends and coworkers with this easy to use calendar for your website.</p>
            <div className="price-tag">
              {standardLoading ? (
                'Loading price...'
              ) : (
                <>
                  <span id="eth-price">Ξ {standardEthPrice}</span>
                  <span id="usd-price">${formatUsdPrice(standardEthPrice)}</span>
                </>
              )}
            </div>
          </Link>

          <Link to="/MagSafeMeshtasticRadio" className="card-item-1 card-item2">
            <img src={mesh} alt="A meshtastic node" />
            <br />
            <br />
            <h3>MagSafe Meshtastic Radio Node</h3>
            <br />
            <p className="carddescription">Digital files for a magSafe compatible radio node for the Meshtastic project.</p>
            <div className="price-tag">
              {meshtasticLoading ? (
                'Loading price...'
              ) : (
                <>
                  <span id="eth-price">Ξ {meshtasticEthPrice}</span>
                  <span id="usd-price">${formatUsdPrice(meshtasticEthPrice)}</span>
                </>
              )}
            </div>
          </Link>

          <Link to="/Orangepi5procase" className="card-item2 card-item-1">
            <img src={orangepi5procase} alt="an rbg enables wardriving device" />
            <br />
            <br />
            <h3>Orange Pi 5 Pro Case</h3>
            <br />
            <p className="carddescription">Digital downloads of a 3D print file for printing 3 styles of case for the orange pi 5 pro.</p>
            <div className="price-tag">
              {orangePiLoading ? (
                'Loading price...'
              ) : (
                <>
                  <span id="eth-price">Ξ {orangePiEthPrice}</span>
                  <span id="usd-price">${formatUsdPrice(orangePiEthPrice)}</span>
                </>
              )}
            </div>
          </Link>
   

          <Link to="/DotAnimation" className="card-item2 card-item-1">
            <img src={dotbackground} alt="a dot background" />
            <br />
            <br />
            <h3>Dynamic Grid Matrix Animation</h3>
            <br />
            <p className="carddescription">Digital downloads of a dot background for your website.</p>
            <div className="price-tag">
              {standardLoading ? (
                'Loading price...'
              ) : (
                <>
                  <span id="eth-price">Ξ {standardEthPrice}</span>
                  <span id="usd-price">${formatUsdPrice(standardEthPrice)}</span>
                </>
              )}
            </div>
          </Link>

          <Link to="/CRTTerminal" className="card-item2 card-item-1">
            <img src={crtterminal} alt="a dot background" />
            <br />
            <br />
            <h3>CRT Terminal Decryption Animation</h3>
            <br />
            <p className="carddescription">Digital downloads of a CRT terminal decryption animation for your website.</p>
            <div className="price-tag">
              {standardLoading ? (
                'Loading price...'
              ) : (
                <>
                  <span id="eth-price">Ξ {standardEthPrice}</span>
                  <span id="usd-price">${formatUsdPrice(standardEthPrice)}</span>
                </>
              )}
            </div>
          </Link>



       </div>
       </div>
    </section>
  );
}

export default Shop;